import React from 'react';
import { AtdwPageTiles } from './view/atdwPageTiles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwPageTiles', 
  itemElt: (item, cmsOption) => <AtdwPageTiles item={item} cmsOption={cmsOption} />
}